import React, { useEffect, useLayoutEffect } from "react";
import Loader from "./Loader";
import Notice from "./Notice";
import Link from "next/link";
import { useSubscriptionPlans } from "../services/hooks/useSubscriptionPlans";
import { useGlobal } from "../services/hooks/useGlobal";
import { useAuth } from "../services/hooks/useAuth";
import { useCart } from "../services/hooks/useCart";

export default function ChooseAPlan() {
  const {
    fetchSubscriptionPlans,
    subscriptionPlans,
    subscriptionPlansError,
    subscriptionPlansStatus,
  } = useSubscriptionPlans();

  const { setShowNav } = useGlobal();

  const { isInCart, addToCart, cartHasSubscription } = useCart();

  const { user, authStatus } = useAuth(true, undefined, "/plans");

  const handlePlanSelect = (product) => {
    addToCart(
      {
        product,
        quantity: 1,
      },
      { silent: true }
    );
  };

  useLayoutEffect(() => {
    setShowNav({
      showNav: false,
    });

    return () => {
      setShowNav({
        showNav: true,
      });
    };
  }, []);

  useEffect(() => {
    if (!subscriptionPlans?.length) {
      fetchSubscriptionPlans();
    }
  }, []);

  if (authStatus !== "ready" || subscriptionPlansStatus !== "ready" || !user) {
    return <Loader />;
  }

  return (
    <section>
      <div className="row">
        <div
          className="col-12 text-center"
          style={{ backgroundColor: "#f4edfd" }}
        >
          <p className="font-size-lg mt-5 px-5">
            Chic Beauty Box is the only beauty subscription full of makeup. We
            like skincare and haircare, we just love makeup a lot - a lot more.
          </p>
        </div>

        <div className="d-block d-lg-none col-12 text-center">
          <img
            style={{ height: "100%", width: "100%" }}
            src="/img/branding/plans/choose-plan.jpg"
          />
        </div>

        <div className="col-12 text-center mt-5 px-8">
          <h2>Choose Your Plan</h2>
          <p>
            All plans automatically renews and you are *committing to the length
            of your plan. Cancel anytime.
          </p>
        </div>

        <div className="col-12 mt-5 mb-3 mb-lg-12 px-8">
          <div className="row">
            <div className="col-12 col-lg-6">
              {subscriptionPlansError ? (
                <div className="quiz-radio-options">
                  <Notice
                    message={subscriptionPlansError}
                    type="danger"
                    dismissable={false}
                  />
                </div>
              ) : (
                <div className="quiz-radio-options">
                  {subscriptionPlans.map((product) => (
                    <div
                      key={product.id}
                      className="quiz-radio-option"
                      onClick={(e) => {
                        e.preventDefault();
                        handlePlanSelect(product);
                      }}
                    >
                      <div className="custom-control custom-radio float-left">
                        <input
                          type="radio"
                          id={product.id}
                          name="subscription-plan"
                          value={product.id}
                          checked={isInCart(product.id)}
                          className="custom-control-input"
                          onChange={(e) => {}}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor={product.id}
                        ></label>
                      </div>
                      <div className="ml-8 quiz-radio-content">
                        <div className="font-size-h6">{product.name}</div>
                        <p className="text-muted">
                          {product.metadata.features.join(". ").toString()}
                        </p>
                      </div>
                    </div>
                  ))}

                  <Link href="/checkout">
                    <a
                      className={`btn btn-block btn-primary ${
                        !cartHasSubscription ? "disabled" : ""
                      }`}
                    >
                      Next
                    </a>
                  </Link>
                </div>
              )}
            </div>
            <div className="d-none d-lg-block col-lg-6 text-center">
              <img
                style={{
                  width: "65%",
                  height: "auto",
                  marginRight: "20%",
                }}
                src="/img/branding/plans/choose-plan.jpg"
              />
            </div>
          </div>
        </div>
        <div className="col-12 text-center px-lg-15 px-8">
          <hr />
          <p className="text-muted font-size-xxs">
            As of March 25, 2021, boxes ship to The United States, Canada,
            United Kingdom, Australia, and most of Europe. Taxes will apply to
            all orders shipped within Canada. Shipping is extra and calculated
            based on your default shipping address.
          </p>
        </div>
      </div>
    </section>
  );
}
